<template>
  <div class="mb-2 w-96">
    <date-time-picker
      v-on:update-datetime-picker="clearTimer"
      :range="range"
      class="mb-2"
    />
    <span class="relative z-0 inline-flex shadow-sm rounded-md w-full">
      <button
        type="button"
        @click="onSevenDays"
        class="relative flex-1  px-4 py-2 items-center rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
      >
        7 {{ $t('message.rangeselector.dias') }}
      </button>
      <button
        type="button"
        @click="onTwoDays"
        class="-ml-px relative flex-1 items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
      >
        2 {{ $t('message.rangeselector.dias') }}
      </button>
      <button
        type="button"
        @click="onNow"
        class="-ml-px relative flex-1 items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
      >
        {{ $t('message.rangeselector.ahora') }}
      </button>
    </span>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import DateTimePicker from '@/components/DateTimePicker';

export default {
  name: 'range-selector',
  components: { DateTimePicker },
  data() {
    return {
    };
  },
  computed: {
    range() {
      return {
        start: this.$store.getters.innerStart,
        end: this.$store.getters.innerEnd
      };
    }
  },
  methods: {
    onNow() {
      var now = dayjs();
      var start = dayjs(this.range.start);
      if (now.diff(start, 'day') > 2) {
        start = now.subtract(2, 'day');
      }
      this.$store.dispatch('updateInnerStart', start.toDate());
      this.$store.dispatch('updateInnerEnd', now.toDate());
    },
    onTwoDays() {
      var now = dayjs(this.range.end);
      var start = now.subtract(2, 'day');
      this.$store.dispatch('updateInnerStart', start.toDate());
      this.$store.dispatch('updateInnerEnd', now.toDate());
    },
    onSevenDays() {
      var now = dayjs(this.range.end);
      var start = now.subtract(7, 'day');
      this.$store.dispatch('updateInnerStart', start.toDate());
      this.$store.dispatch('updateInnerEnd', now.toDate());
    },
    clearTimer() {
    }
  }
};
</script>
